import { useEffect, useMemo, useState } from "react";
import { useSortBy } from "react-instantsearch-hooks-web";
import { useWorkbenchStore } from "../../store/store";
import { sortOptions, mapSortToReplica } from "./FilterTransforms";

const SortedBy = () => {
  const resetSortedIndexName = useWorkbenchStore(
    (state) => state.resetSortedIndexName
  );
  const sortedIndexName = useWorkbenchStore((state) => state.sortedIndexName);
  const [footerDisplayName, setFooterDisplayName] = useState("");

  const baseIndexName = document.getElementById("mm-browse-beta-container") ?.getAttribute("data-index-name") || "";
  const items = useMemo(
    () =>
      sortOptions.map((opt) => ({
        label: opt.text,
        value: mapSortToReplica(baseIndexName, opt.value),
      })),
    [baseIndexName]
  );
  const { refine } = useSortBy({ items });

  const handleClearClick = () => {
    refine(mapSortToReplica(baseIndexName, "default"));
    resetSortedIndexName();

    const url = new URL(window.location.href)
    url.searchParams.delete("sort")
    window.history.replaceState({}, "", url.toString())
  };

  useEffect(() => {
    // Sets display name in Footer for sort option
    // index name looks like "local_song_versions_[filter value]"
    // so this finds which option has the filter value that the index name ends with
    const match = sortOptions.find((option) => sortedIndexName.endsWith(option.value))
    setFooterDisplayName(match ? match.text : "")
  }, [sortedIndexName]);

  return (
    <div className="sorted-by">
      <div className="label">Sorted By:</div>
      <ul>
        <li data-filter="sort">
          {footerDisplayName}
          <span onClick={handleClearClick}>x</span>
        </li>
        <li
          className="clear-all"
          data-clear="sort"
          data-cy="clearSort"
          onClick={handleClearClick}
        >
          Clear
        </li>
      </ul>
    </div>
  );
};

export default SortedBy;
